const calloutStyle = {
  section_wrapper: `landing_page_component_wrapper w-full flex flex-col items-center justify-center text-center container !pb-[5px]`,
  heading: `text-white font-Suisse font-[900] uppercase italic text-[18px] leading-[24px] max-w-[90%] tracking-normal [word-spacing:0.12em]
            screen-500:text-[22px] screen-500:leading-[28px]
            sm:text-[25px] sm:leading-[32px]
            md:text-[28px] md:leading-[36px] md:max-w-[700px]
            lg:text-[32px] lg:leading-[40px] lg:max-w-[850px]
            xl:text-[35px] xl:leading-[44px] xl:max-w-[950px]`,
  highlight: `text-primaryHeading`,
};

export { calloutStyle };
